import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { OverallDataContext } from '../../pages/CalculatorPage';

export default function ButtonSelectField({ id_name, category, onChangeHandler, options, setFocus, isRequired, isReadOnly, default_val }) {
    const placeholderData = useContext(OverallDataContext).placeholderData;
    const [fieldValue, setFieldValue] = useState('');

    const handleOnChange = (field_value) => {
        if (field_value !== null) {
            setFieldValue(field_value)
            let fieldData = {
                name: id_name,
                value: field_value,
            }
            onChangeHandler(fieldData);
        }
    }

    useEffect(()=>{
        setFieldValue(placeholderData?.[category]?.[id_name]);
    },[placeholderData])

    useEffect(()=>{
        setFieldValue(default_val)
    },[default_val])

    return (
        <ToggleButtonGroup
            fullWidth
            exclusive
            orientation="vertical"
            name={ id_name } id={ id_name } 
            value={fieldValue}
            onChange={(event, newValue) => handleOnChange(newValue)}
            required={isRequired}
            readOnly={isReadOnly}
            disabled={isReadOnly}
            onFocus={() => setFocus(true)}
            onBlur={() => setFocus(false)}
            sx={{ borderRadius: '32px' }}
            color="primary"
        >
            {
                options.map((opt, idx) => {
                    const opt_label = opt.label ? opt.label : opt.value;
                    return (
                        <ToggleButton 
                            key={idx} 
                            className='rounded-toggle-btn' 
                            value={opt.value}
                            sx={{ textTransform: 'none' }}
                        >
                            {opt_label}
                        </ToggleButton>
                    )
                })
            }
        </ToggleButtonGroup>
    )
}